import $ from 'jquery';
import Backbone from 'backbone';
import ChartDetailsTemplate from '@/templates/data/chart-details.hbs';
import ChartPieTableTemplate from '@/templates/data/chart-pie-table.hbs';
import ChartTableTemplate from '@/templates/data/chart-table.hbs';
import ChartView from '@/data/views/chart';
import EmbedFormView from '@/data/views/embed_form';
import MapTableTemplate from '@/templates/data/map-table.hbs';
import 'bootstrap/js/dist/dropdown';

export default Backbone.View.extend({
  events: {
    'click .chart-action-print': 'print',
    'click .chart-action-download-spreadsheet': 'downloadSpreadsheet',
    'click .chart-action-download-png': 'downloadPng',
    'click .chart-action-download-pdf': 'downloadPdf',
    'click .chart-action-download-svg': 'downloadSvg',
  },

  initialize: function(options) {
    this.options = options;

    this.render();

    this.embedForm = new EmbedFormView({
      el: "#" + this.el.id + " #embed-form",
      model: this.model
    });
  },

  render: function() {
    this.main_chart = new ChartView({
      el: "#"+this.el.id +" div.chart-display",
      model: this.model,
    });
    this.render_details();
    this.render_hidden_table();
  },

  update_model: function(new_model) {

    // do nothing if  new model is null
    if (new_model != undefined  ) {
      this.model = new_model;
    }

    this.embedForm.update_model(this.model);

    // update the main chart
    if (this.main_chart != undefined) {
      this.main_chart.destroy();
    }
    // Without wrapping render in a time out,
    // firefox sometimes fails to add some functionality - like tooltips and clickable legend.
    // setTimeout(_.bind(this.render, this), 0);
    this.render();
  },

  // set the hidden table
  render_hidden_table: function() {   
    if (this.main_chart.model.get("renderer") == "highcharts") {
      if (this.main_chart.model.get("chart_type") == "pie") {
        this.$el.find("div.chart-table").html(ChartPieTableTemplate(this.model.toJSON()));
      }
      else {
        this.$el.find("div.chart-table").html(ChartTableTemplate(this.model.toJSON()));
      }
    }
    else if (this.main_chart.model.get("renderer") == "google-geocharts") {
      this.$el.find("div.chart-table").html(MapTableTemplate(this.model.toJSON()));
    }
    else {
      this.$el.find("div.chart-table").html("");
    }
  },
  //populates (or overwrites) chart details based on current active chart
  render_details: function() {
    // update chart info
    if (window.chart_only != 'true') {
      const description = ChartDetailsTemplate(this.model.toJSON());
      this.$el.find("div.chart-description").html(description);
      this.$el.find("div.hidden-chart-description").html(description);
    }
    if (window.chart_only == 'true' && this.main_chart.model.get('renderer') == 'unknown') {
      const description = ChartDetailsTemplate(this.model.toJSON());
      this.$el.find("div.chart-description").html(description);
      this.$el.find("div.hidden-chart-description").html(description);
      $(".chart-description p").css('display', 'none');
    }
  }, 

  print() {
    this.main_chart.chart.print();
  },

  downloadSpreadsheet() {
    window.location = this.model.get("spreadsheet");
  },

  downloadPng() {
    this.main_chart.chart.exportChartLocal({ type: 'image/png' });
  },

  downloadPdf() {
    this.main_chart.chart.exportChartLocal({ type: 'application/pdf' });
  },

  downloadSvg() {
    this.main_chart.chart.exportChartLocal({ type: 'image/svg+xml' });
  },
});
